import React, { useState } from "react";
import { HiMenuAlt1 } from "react-icons/hi";
import { RxCrossCircled } from "react-icons/rx";
import profile from "../../assets/images/profile.jpg";
import NavLinks from "../../components/NavLinks";

const SideNav = () => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div
      className={`navbar bg-bgSecondary min-h-screen ${
        isOpen ? "translate-x-[-280px]" : "translate-x-0"
      }  md:translate-x-0 lg:translate-x-0    md:block lg:block fixed z-[999] `}
    >
      {/* toggle bar */}

      <div className="absolute top-4 left-[300px] md:hidden lg:hidden text-white z-[999]">
        <h2 onClick={toggle} className="text-white font-bold text-3xl pointer">
          {isOpen ? <HiMenuAlt1 /> : <RxCrossCircled />}
        </h2>
      </div>

      <nav>
        <div className="profileImg flex justify-center w-[280px] py-8">
          <img
            className="w-[170px] rounded-full border-[4px] border-primary "
            src={profile}
            alt=""
          />
        </div>

        {/* links */}

        {/* navBar links */}

    <div onClick={toggle} >
    <NavLinks  />
    </div>

        {/* footer */}

        <footer className="">
          <p className="text-white text-center pt-7 ">
            Mahamodul Hasan Moon &copy; 2023
          </p>
        </footer>
      </nav>
    </div>
  );
};

export default SideNav;
